import React, { useState } from 'react';
import { TextField, Button, Container, Typography } from '@mui/material';
import axios from 'axios';
import { useHistory } from 'react-router-dom'; // For redirecting after success

const AdminRegisterPage = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const history = useHistory(); // Initialize history for redirection

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/admin/register`, {
                name,
                email,
                password
            });
            setSuccess(true);
            setError('');
            setTimeout(() => history.push('/login'), 2000); // Redirect to login page after 2 seconds
        } catch (err) {
            setError(err.response?.data?.message || 'Registration failed');
            setSuccess(false);
        }
    };

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                Admin Registration
            </Typography>
            {success && <Typography variant="body1" color="success.main">Registration successful! Redirecting to login...</Typography>}
            {error && <Typography variant="body1" color="error.main">{error}</Typography>}
            <form onSubmit={handleSubmit}>
                <TextField
                    label="Name"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    autoComplete="name"
                />
                <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                />
                <TextField
                    label="Password"
                    type="password"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="current-password" // Updated this line
                />
                <Button type="submit" variant="contained" color="primary">
                    Register
                </Button>
            </form>
        </Container>
    );
};

export default AdminRegisterPage;